import { Container, Grid } from "@mui/material";

import HomeIcon from "@mui/icons-material/Home";
import FeedIcon from "@mui/icons-material/Feed";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";

import CustomForm from "../../../helper-components/form/CustomForm.jsx";
import NavigationFooter from "../../../helper-components/misc/NavigationFooter.jsx";

import PatientsTable from "./components/PatientsTable";

import { getLanguage } from "../../../config/language/language.js";

export default function Patients(props) {
    return (
        <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <CustomForm title={getLanguage().PATIENTS_TITLE} subtitle={getLanguage().PATIENTS_SUBTITLE} icon={<PermContactCalendarIcon />} />
                </Grid>

                <Grid item xs={12}>
                    <PatientsTable {...props} />
                </Grid>

                <NavigationFooter
                    rows={1}
                    options={[
                        {
                            path: `/home`,
                            title: "Home",
                            variant: "outlined",
                            icon: <HomeIcon />
                        },
                        {
                            path: `/database/examinations`,
                            title: "Examinations",
                            variant: "outlined",
                            icon: <FeedIcon />
                        }
                    ]}
                />
            </Grid>
        </Container>
    );
}
